var i = 0;
module.exports = function(prefix){
  return function(){
    i++;
    return prefix + i.toString(36);
  };
};



//////////////////
// WEBPACK FOOTER
// /Users/sameer/Documents/projects/release/metabase/~/gen-css-identifier/factory.js
// module id = 1553
// module chunks = 3